import { baseBackend } from "../../../../../api/base/baseUrl";

const RATES_CLIENT_CITY_TO_CITY_URL = "/api/v2/rates/clients/city_to_city";

export async function getClientCityToCityListRequest() {
  const response = await baseBackend.get(RATES_CLIENT_CITY_TO_CITY_URL);
  return response.data;
}

export async function getClientCityToCityByIdRequest(id) {
  const response = await baseBackend.get(
    `${RATES_CLIENT_CITY_TO_CITY_URL}/id/${id}`,
  );
  return response.data;
}

export async function createClientCityToCityRequest(payload) {
  const response = await baseBackend.post(
    RATES_CLIENT_CITY_TO_CITY_URL,
    payload,
  );
  return response.data;
}

export async function updateClientCityToCityRequest(payload) {
  const response = await baseBackend.put(
    RATES_CLIENT_CITY_TO_CITY_URL,
    payload,
  );
  return response.data;
}

export async function deleteClientCityToCityRequest(id) {
  const response = await baseBackend.delete(
    `${RATES_CLIENT_CITY_TO_CITY_URL}/id/${id}`,
  );
  return response.data;
}
